import Socials from './Socials'

export default Socials


// WEBPACK FOOTER //
// ./src/components/Header/Socials/index.js